// Parameter field names, shared by Layout.js (the schema) and the page (formRefs lookups, validation
// and the Date to Use rule). Declared once so a rename cannot silently break the page's imperative
// field access, which is keyed by these exact strings.
export const FIELD = Object.freeze({
    DateToUse: "DateToUse",
    AsOfDate: "AsOfDate",
    CalculatedDays: "CalculatedDays",
    ZeroCharges: "ZeroCharges",
    Comment: "Comment",
});

// WMD0012 "Date to Use" combo (uWMD0012.dfm edtDateToUse, Codes 'C'/'S'). Mirrors
// Argos.Core/Constants/FreeDaysGracePeriodConstants.cs -> FreeDaysDateToUse.
export const DateToUse = Object.freeze({
    Calculated: "C",
    SpecificDate: "S",
});

// WMD0012 "$0 Charges" combo -> @inDeleteZeroCharges. Mirrors FreeDaysZeroCharges.
export const ZeroCharges = Object.freeze({
    Save: "S",
    Delete: "D",
});

// Combo captions verbatim from uWMD0012.dfm.
export const DATE_TO_USE_OPTIONS = [
    { key: DateToUse.Calculated, value: "Calculated from Current Date" },
    { key: DateToUse.SpecificDate, value: "Specific As Of Date" },
];

export const ZERO_CHARGES_OPTIONS = [
    { key: ZeroCharges.Save, value: "Save" },
    { key: ZeroCharges.Delete, value: "Delete" },
];

// WMTRANSACTIONCHARGE.CHARGETIMING. Mirrors Argos.Core/Constants -> ChargeTiming. Only F and G are
// reachable on this screen: the batch selects those two and writes R on everything it processes.
export const ChargeTiming = Object.freeze({
    FreeDays: "F",
    GracePeriod: "G",
});

// WMTRANSACTIONCHARGE.CHARGETYPE. Mirrors Argos.Core/Constants -> ChargeTypes.
export const ChargeType = Object.freeze({
    ItemCharge: "I",
    TransactionCharge: "T",
});

// Grid <Lookup> sources. DevExtreme's default lookup keys, hence id/text rather than the key/value
// pair the dynamic-form SelectBox uses above.
export const CHARGE_TIMING_OPTIONS = [
    { id: ChargeTiming.FreeDays, text: "Free Days" },
    { id: ChargeTiming.GracePeriod, text: "Grace Period" },
];

export const CHARGE_TYPE_OPTIONS = [
    { id: ChargeType.ItemCharge, text: "Item Charge" },
    { id: ChargeType.TransactionCharge, text: "Transaction Charge" },
];

// Saved-layout identity for the Preview grid, and GridLayoutManager's built-in layout name used as
// the initial currentLayout state.
export const PREVIEW_GRID_KEY = "5A1D9C34-8E62-4B07-93F1-7C2A5E8D016B";
export const DEFAULT_LAYOUT_NAME = "Default";

// Dynamic-form layout identity for the parameters panel.
export const LAYOUT_ID = "3F8B21C4-7A56-4D19-9C03-6E45D2B18A70";
export const LAYOUT_NAME = "WMUpdateFreeDaysGracePeriodsForm";

// Filter-field definitions come from Argos.Core/Report/WM/WMUpdateFreeDaysGracePeriods.cs via
// ReportFactory's "WMUPDATEFREEDAYSGRACEPERIODS" case.
export const REPORT_NAME = "WMUpdateFreeDaysGracePeriods";
export const REPORT_FULL_NAME = "Argos.Report.WM.WMUpdateFreeDaysGracePeriods, Argos.Report.WM";

export const PAGE_TITLE = "Update Free Days and Grace Periods";

// The legacy result dialog is TfrmABD0013, titled "Process Complete (ABD0013)" with the caption passed
// in by the caller (uWMD0012.pas:195 passes "Charges Updated"). The web title reuses the shared
// MESSAGES.PROCESS_COMPLETE and drops the "(ABD0013)" form id, which means nothing outside Delphi.
export const RESULT_CAPTION = "Charges Updated";

export const RESULT_LABELS = Object.freeze({
    BatchNumber: "Batch Number",
    RecordsProcessed: "Records Processed",
});

export const RESULT_OK = "OK";

export const PREVIEW_TITLE = "Preview";

// Toolbar button captions, verbatim from the Delphi form (uWMD0012.dfm grpBottomButtons). Help and
// Exit are not migrated: Help opened a Delphi context topic and Exit closed the MDI child.
export const BUTTON = Object.freeze({
    Start: "Start",
    Preview: "Preview",
    Reset: "Reset",
});

// @inComment on SPWM_BATCHFREEDAYSGRACEPERIOD is varchar(128).
export const COMMENT_MAX_LENGTH = 128;

// The procedure alone is allowed 900s, and Start also runs the count and the optional repair.
export const REQUEST_TIMEOUT_MS = 20 * 60 * 1000;
